<template>
  <button :type="type"
          :disabled="disabled"
          class="transition-colors rounded-full flex items-center justify-center gap-2 text-sm font-medium"
          :class="{
            'border border-green-100 text-green-100 hover:bg-green-50 hover:text-green-200 disabled:border-grey-300 disabled:text-grey-300': variant === 'outline',
            'bg-green-100 enabled:hover:bg-green-200 text-white disabled:bg-green-100': variant === 'primary',
            'bg-transparent text-green-100 hover:text-green-200 disabled:text-green-400': variant === 'transparent',
            'bg-grey-50 text-black !font-bold hover:text-black hover:bg-grey-600/60 disabled:text-black': variant === 'glass',
            'px-2 py-1 text-xs': size === 'sm',
            'px-4 py-3 text-sm': size === 'md',
            'px-6 py-4 text-lg': size === 'lg',
          }"
  >
    <slot></slot>
  </button>
</template>

<script setup>
const props = defineProps({
  variant: {
    type: String,
    default: 'primary',
    validator: (value) => ['primary', 'outline', 'dark', 'light', 'bare', 'transparent', 'link', 'glass'].includes(value),
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg'].includes(value),
  },
  type: {
    type: String,
    default: 'button',
    validator: (value) => ['button', 'submit', 'reset'].includes(value),
  },
});
</script>
